var _defs, _style, _path, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstraintLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ellipse 56-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 48,
    height: 42,
    id: "img1",
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0OCA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjU5ODEgNDAuNUMyNS40NDM0IDQyLjUgMjIuNTU2NiA0Mi41IDIxLjQwMTkgNDAuNUwwLjYxNzMxIDQuNUMtMC41MzczOTIgMi41IDAuOTA1OTgzIDQuNjQxNjNlLTA2IDMuMjE1MzkgNC40Mzk3M2UtMDZMNDQuNzg0NiA4LjA1NjM1ZS0wN0M0Ny4wOTQgNi4wMzc0MWUtMDcgNDguNTM3NCAyLjUgNDcuMzgyNyA0LjVMMjYuNTk4MSA0MC41WiIgZmlsbD0iI0ZDOUQyQyIvPgo8L3N2Zz4K"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff;stroke: #81818c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m14 27.5c-7.5 0-13.5-6-13.5-13.5c0-7.5 6-13.5 13.5-13.5c7.5 0 13.5 6 13.5 13.5c0 7.5-6 13.5-13.5 13.5z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Polygon 4(1)",
    href: "#img1",
    transform: "matrix(.417,0,0,.5,4,6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstraintLog);
export default __webpack_public_path__ + "static/media/ConstraintLog.050e168d.svg";
export { ForwardRef as ReactComponent };